import * as AppConstants from "AppConstants";

export const getForgotPasswordUrl = () => {
    return AppConstants.FORGOT_PASSWORD_ENDPOINT;
};

export const getVerifyOtpUrl = () => {
    return AppConstants.VERIFY_OTP_ENDPOINT;
};

export const getResetPasswordUrl = () => {
    return AppConstants.RESET_PASSWORD_ENDPOINT;
};

export const getAdminInitiateResetUrl = () => {
    return AppConstants.ADMIN_INITIATE_RESET_ENDPOINT;
};
